import React from 'react';
import {Row, Col, Input } from 'antd';
import { useTranslation } from 'react-i18next';

const RepLegal = ({repLegal={}, actual}) => {
    const { t } = useTranslation();
    return (
        <div>
            <Row gutter={[32, 12]}>
                <Col span={6}>
                {t("messages.aml.fullName")}
                <Input readOnly value={repLegal.name} className={actual && repLegal.name !== actual.name && "difference"}/>
                </Col>
                <Col span={6}>
                {t("messages.aml.identificationNumber")}
                <Input readOnly value={repLegal.nroid} className={actual && repLegal.nroid !== actual.nroid && "difference"}/>
                </Col>
                <Col span={6}>
                {t("messages.aml.documentType")}
                <Input readOnly value={repLegal.tipoDoc} className={actual && repLegal.tipoDoc !== actual.tipoDoc && "difference"}/>
                </Col>
                <Col span={6}>
                {t("messages.aml.email")}
                <Input readOnly value={repLegal.correo} className={actual && repLegal.correo !== actual.correo && "difference"}/>
                </Col>
                <Col span={6}>
                {t("messages.aml.birthDate")}
                <Input readOnly value={repLegal.fecNac} className={actual && repLegal.fecNac !== actual.fecNac && "difference"}/>
                </Col>
                <Col span={6}>
                {t("messages.aml.nationality")}
                <Input readOnly value={repLegal.nationality} className={actual && repLegal.nationality !== actual.nationality && "difference"}/>
                </Col>
                <Col span={6}>
                {t("messages.aml.profession")}
                <Input readOnly value={repLegal.profesion} className={actual && repLegal.profesion !== actual.profesion && "difference"}/>
                </Col>
                <Col span={6}>
                {t("messages.aml.isShareholder")}
                <Input readOnly value={repLegal.esAccionista} className={actual && repLegal.esAccionista !== actual.esAccionista && "difference"}/>
                </Col>
                <Col span={6}>
                {t("messages.aml.contactPhone")}
                <Input readOnly value={repLegal.telefono} className={actual && repLegal.telefono !== actual.telefono && "difference"}/>
                </Col>
            </Row>
        </div>
    );
};

export default RepLegal;